export default __webpack_public_path__ + "pgnv-assets/3904b6b413bf359066f9105ae333fd73.png";